import types from './actionTypes';

const initialState = {
  loading: false,
  insights: [],
  startDate: null,
  endDate: null,
  error: '',
};

const dailyCompanyInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DAILY_COMPANY_INSIGHT_STATE:
      return initialState;
    case types.DAILY_COMPANY_INSIGHTS.REQUEST:
      return {
        ...state,
        loading: true,
        insights: [],
        error: '',
      };
    case types.DAILY_COMPANY_INSIGHTS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        insights: action.insights,
        startDate: action.startDate,
        endDate: action.endDate,
      };
    case types.DAILY_COMPANY_INSIGHTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default dailyCompanyInsightsReducer;
